export const slideVariants = {
  enter: (direction) => ({
    opacity: 0,
    // start fully off-screen in the direction of travel so the slide is hidden
    x: direction > 0 ? '100%' : '-100%',
    scale: 0.995,
    // fade in a bit slower and slide in more gently
    transition: {
      opacity: { duration: 0.45, ease: 'easeOut' },
      x: { duration: 0.75, ease: 'easeOut' },
    },
  }),
  center: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { duration: 0.75, ease: 'easeOut' },
  },
  exit: (direction) => ({
    opacity: 0,
    x: direction < 0 ? '100%' : '-100%',
    scale: 0.995,
    // let the outgoing image fade out a bit longer so user sees the fade
    transition: {
      opacity: { duration: 0.45, ease: 'easeIn' },
      x: { duration: 0.6, ease: 'easeIn' },
    },
  }),
};

export const captionVariants = {
  hidden: { opacity: 0, y: 18 },
  show: {
    opacity: 1,
    y: 0,
    transition: { delay: 0.15, duration: 0.45, ease: 'easeOut' },
  },
  exit: { opacity: 0, y: 10, transition: { duration: 0.3 } },
};
